import React from 'react';
import { ResponsiveContainer, BarChart, XAxis, Tooltip, Bar, Text } from 'recharts';
import CustomTooltip from '../CustomTooltip'

class GraphTopTrackers extends React.Component {

  shortenName = (text) => {
    if (text.length > 13) {
      return text.slice(0, 10) + '...'
    }
    return text;
  }

  render() {
    const { t } = this.props

    return (
      <div style={styles.container}>
        <p style={styles.title}>{t('Top 5 Skill Trackers')}</p>
        <ResponsiveContainer width="100%" minWidth={300} height={350}>
          <BarChart data={this.props.data}>
            <XAxis dataKey="name" tickLine={false} tickFormatter={this.shortenName} axisLine={{ stroke: '#67B5E7' }} allowData />
            <defs>
              <linearGradient id="linear" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#53A8E2" />
                <stop offset="100%" stopColor="#76DFFB" />
              </linearGradient>
            </defs>
            <Bar dataKey="value" fill="url(#linear)" />
            <Tooltip
              content={<CustomTooltip data={this.props.data} />}
              wrapperStyle={styles.wrapper}
              labelStyle={styles.label}
              itemStyle={styles.label}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

export default GraphTopTrackers;

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none',
    borderRadius: 3
  },

  label: {
    fontSize: '11px'
  },

  container: {
    maxWidth: '600px',
    width: '100%'
  },

  title: {
    fontSize: '16px',
    color: '#485465'
  },
}



// WEBPACK FOOTER //
// ./src/components/GraphTopTrackers/index.jsx